import React, { useEffect, useState } from 'react';

interface FilePreviewProps {
    file: File;
    maxWidth?: number;
    maxHeight?: number;
    testId?: string;
}

export default function FilePreview({ file, maxWidth = 300, maxHeight = 200, testId }: FilePreviewProps) {
    const [objectUrl, setObjectUrl] = useState<string | null>(null);

    useEffect(() => {
        // Create object URL for the file
        const url = URL.createObjectURL(file);
        setObjectUrl(url);

        // Cleanup function to revoke the object URL
        return () => {
            URL.revokeObjectURL(url);
        };
    }, [file]);

    if (!objectUrl) {
        return null;
    }

    const containerStyle = {
        width: maxWidth,
        border: '1px solid #C4C4C4',
        borderRadius: '5px',
        padding: '10px',
        marginTop: '10px',
        backgroundColor: '#f9f9f9',
        boxSizing: 'border-box' as const
    };

    const isPdf = file.type === 'application/pdf';
    const isImage = file.type.startsWith('image/');

    return (
        <div style={containerStyle} data-testid={testId}>
            <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
                {file.name}
            </div>

            {isPdf && (
                <object
                    data={objectUrl}
                    width={maxWidth - 20}
                    height={maxHeight}
                    type="application/pdf"
                    style={{ border: 'none' }}
                    data-testid={`${testId}-pdf-object`}
                >
                    <p>PDF preview not supported in this browser.</p>
                </object>
            )}

            {isImage && (
                <img
                    src={objectUrl}
                    alt={file.name}
                    style={{
                        maxWidth: maxWidth - 20,
                        maxHeight: maxHeight,
                        objectFit: 'contain',
                        border: 'none'
                    }}
                    data-testid={`${testId}-image`}
                />
            )}

            {!isPdf && !isImage && (
                <div style={{
                    width: maxWidth - 20,
                    height: 100,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f0f0',
                    border: '1px dashed #ccc',
                    color: '#666'
                }}>
                    File type not supported for preview
                </div>
            )}
        </div>
    );
}